export const TABLE_COLOR_BY_STATUS = {
    "FREE": "green",
    "OCCUPIED": "orange",
    "RESERVED" : "red",
    "INACTIVE": "gray"
}